<template>
  <div class="content">
    <pre>

      <button @click="action1">컨펌 실행</button>
      결과 : {{ action1_result }}

      <button @click="action2">알럿 실행</button>
      결과 : {{ action2_result }}

      <button @click="action2_err">오류 알럿</button>

      <button @click="action3">알림(일반)</button>

      <button @click="action4">알림(중앙 아래 옵션사용)</button>

    </pre>
  </div>
</template>

<script>
let ui
export default {
  data() {
    return {
      action1_result : null,
      action2_result : null,
    }
  },

  created() {
    ui = this.$ui;
  },

  methods: {
    action1() {
      ui.confirm('저장하시겠습니까 ?', "저장확인")
        .then(r => this.action1_result = r)
    },
    action2() {
      ui.alert('정말로 등록하시겠습니까 ?', "최종확인")
        .then(r => this.action2_result = r)
    },
    action2_err() {
      ui.alert('정말로 등록하시겠습니까 ?', "오류", {type: 'error'})
    },
    action3() {
      ui.notify("알림입니다...")
    },
    action4() {
      ui.notify("개발 메모가 수정되었습니다.", {group: 'bottom', type: 'success'})
    },

  },
}
</script>